<template>
  <oculis>
    
    <v-card class="mb-6 elevation-2">
      <alert></alert>
      <v-card-text class="py-12">
        <div class="d-flex flex-column align-center justify-center text-center" style="max-width: 800px; margin: 0 auto; gap: 1rem;">
          <h5 class="text-h4 font-weight-bold">
            Eye Tracking & Analytics
            <span class="primary--text">Hub</span>
          </h5>
          <p class="text-body-1 grey--text text--darken-1">
            Analyze project data, draw AOIs, and generate heatmaps in one centralized workspace.
          </p>
          <div class="mt-4">
            <v-btn color="primary" large rounded @click="showCreateModal = true">
              <v-icon left>{{ icons.mdiPlus }}</v-icon>
              New Project
            </v-btn>
          </div>
          <!-- <div class="d-flex align-center mt-4 search-field" style="width: 100%; max-width: 600px;">


            <v-autocomplete
                  v-model="decipherProject"
                  :items="decipherProjects"
                  :loading="decipherProjectLoading"
                  :search-input.sync="projectDecipherSearch"
                  item-value="path"
                  item-text="path"
                  label="Search Decipher Projects..."
                  outlined
                  dense
                  persistent-hint
                  hint="Type at least 3 letters..."
                  @change="projectDecipherSearch=''"
                  class="mr-2"
                  return-object>
                      <template #no-data>
                          <p class="ml-2" style="color: gray">No results found</p>
                      </template>
              </v-autocomplete>

              <v-autocomplete
                  v-model="lighthouseProject"
                  :items="lighthouseProjects"
                  :loading="lighthouseProjectLoading"
                  :search-input.sync="projectSearchQuery"
                  item-value="id"
                  label="Search LH Projects"
                  outlined
                  dense
                  persistent-hint
                  hint="Type at least 3 letters..."
                  @change="projectSearchQuery=''"
                  return-object>
                      <template #no-data>
                          <p class="ml-2" style="color: gray">No results found</p>
                      </template>
              </v-autocomplete>
          </div>
              <v-btn color="primary" @click="createProject" :loading="projectCreationLoading" :disabled="createDisabled">Create</v-btn> -->
        </div>

        <!-- Illustrations (Hidden on small screens) -->
        <img src="@/assets/images/oculis/met-glasses.png" 
             class="illustration-right d-none d-md-block" height="180" />
        <img src="@/assets/images/oculis/target_eye.png" 
             class="illustration-left d-none d-md-block" height="100" />
      </v-card-text>
    </v-card>

    <v-row>
      <!-- Decipher Search Results -->
      <!-- <v-col cols="12" md="6">
        <v-card class="fill-height">
          <v-card-title>Decipher Project Search</v-card-title>
          <v-card-text>
            <v-data-table
              :headers="decipherHeaders"
              :items="decipherProjectsData"
              :loading="decipherProjectLoading"
               @click:row="decipherProjectClick"
              dense
            ></v-data-table>
          </v-card-text>
        </v-card>
      </v-col> -->

      <!-- Past Projects -->
      <v-col cols="12" md="12">
        <v-card class="fill-height">
          <v-card-title>
            Projects
            <v-spacer></v-spacer>
            <v-text-field
              v-model="oculisProjectSearch"
              :append-icon="icons.mdiMagnify"
              label="Search"
              single-line
              hide-details
              dense
              outlined
              style="max-width: 300px;"
            ></v-text-field>
          </v-card-title>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="projectsData"
              :loading="projectLoading"
              dense
              :server-items-length="totalProjects"
              :options.sync="options"
              :footer-props="{
                  'items-per-page-options':[options.itemsPerPage],
                  'disable-items-per-page': true,
              }"
            >
              <template #item.job_number="{ item }">
                <div class="d-flex flex-column">
                  <router-link :to="{ name: 'oculis-id', params: { id: item.id } }" class="text-decoration-none font-weight-bold">
                    {{ item.job_number }}
                  </router-link>
                  <span class="text-caption grey--text">{{ item.job_name }}</span>
                </div>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  
    <!-- Create Project Modal -->
    <v-dialog v-model="showCreateModal" max-width="600" persistent>
      <v-card>
        <v-card-title class="text-h5 grey lighten-4">
          Create New Project
        </v-card-title>

        <!-- State 1: Input Fields -->
        <v-card-text v-if="!projectCreationLoading" class="pt-6">
          <v-autocomplete
            v-model="decipherProject"
            :items="decipherProjects"
            :loading="decipherProjectLoading"
            :search-input.sync="projectDecipherSearch"
            item-value="path"
            item-text="title"
            label="Search Decipher Projects..."
            outlined
            dense
            persistent-hint
            hint="Type at least 3 letters..."
            @change="projectDecipherSearch=''"
            class="mb-4"
            return-object>
            <template #no-data>
              <p class="ml-2 mt-2" style="color: gray">No results found</p>
            </template>
          </v-autocomplete>

          <v-autocomplete
            v-model="lighthouseProject"
            :items="lighthouseProjects"
            :loading="lighthouseProjectLoading"
            :search-input.sync="projectSearchQuery"
            item-value="id"
            label="Search LH Projects"
            outlined
            dense
            persistent-hint
            hint="Type at least 3 letters..."
            @change="projectSearchQuery=''"
            return-object>
            <template #no-data>
              <p class="ml-2 mt-2" style="color: gray">No results found</p>
            </template>
          </v-autocomplete>
        </v-card-text>

        <!-- State 2: Rotating Loading Progress -->
        <v-card-text v-else class="text-center py-12">
          <v-progress-linear 
            indeterminate 
            color="primary" 
            height="6" 
            rounded 
            class="mb-6"
          ></v-progress-linear>
          
          <transition name="fade" mode="out-in">
            <h3 :key="currentLoadingText" class="text-h6 primary--text font-weight-medium">
              {{ currentLoadingText }}
            </h3>
          </transition>
          <p class="text-caption grey--text mt-2">This may take a few minutes depending on data size.</p>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions v-if="!projectCreationLoading">
          <v-spacer></v-spacer>
          <v-btn text color="grey darken-1" @click="closeModal">Cancel</v-btn>
          <v-btn color="primary" @click="createProject" :disabled="createDisabled">Create Project</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </oculis>
</template>

<script>
import store from '@/store'
import { ref, onMounted, onUnmounted, computed, watch } from '@vue/composition-api'
import Oculis from '@/views/apps/oculis/Oculis.vue'
import { mdiMagnify, mdiPlus } from '@mdi/js'
import useOculis from '../useOculis'
import usePOG from '@/views/apps/skutopia/pog/usePOG'
import projectStoreModule from '@/views/apps/project/projectStoreModule'
import Alert from '@/views/components/alert/Alert.vue'
import { useRouter } from '@core/utils'

export default {
  components:{
    Oculis,
    Alert
  },
  setup() {
    const PROJECT_APP_STORE_MODULE_NAME = 'app-project'
    // Register module
    if (!store.hasModule(PROJECT_APP_STORE_MODULE_NAME)) store.registerModule(PROJECT_APP_STORE_MODULE_NAME, projectStoreModule)
    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(PROJECT_APP_STORE_MODULE_NAME)) store.unregisterModule(PROJECT_APP_STORE_MODULE_NAME)
    })
    const { router } = useRouter()

    const showCreateModal = ref(false)
    const projectDecipherSearch = ref('')
    const lighthouseProject = ref(null)
    const decipherProject = ref({})
    const {
      projectsData, projectLoading, projectCreationLoading, lighthouseProjectLoading,
      decipherProjectLoading, decipherProjectsData, options, totalProjects, oculisProjectSearch,
      fetchDecipherProjects, addProject
    } = useOculis()

    const {
      projectSearchQuery,
      lighthouseProjectsData,

      fetchProjects
    } = usePOG()

    const loadingMessages = [
      'Connecting to Decipher...',
      'Downloading survey data...',
      'Identifying media files...',
      'Retrieving images...',
      'Loading fixation data...',
      'Calculating coordinates...',
      'Finalizing project setup...'
    ]
    const currentMessageIndex = ref(0)
    let loadingInterval = null

    const currentLoadingText = computed(() => loadingMessages[currentMessageIndex.value])

    const startLoadingAnimation = () => {
      currentMessageIndex.value = 0
      loadingInterval = setInterval(() => {
        // Stop advancing if we hit the last message, let it sit there until API finishes
        if (currentMessageIndex.value < loadingMessages.length - 1) {
          currentMessageIndex.value++
        }
      }, 4000) // Changes text every 4 seconds
    }

    const stopLoadingAnimation = () => {
      if (loadingInterval) clearInterval(loadingInterval)
    }



    const headers = [
      { text: 'Project', value: 'job_number' },
      { text: 'Country', value: 'country', sortable: false },
      { text: 'Type', value: 'project_type' },
      { text: 'Service', value: 'service_type' },
      { text: 'Client', value: 'client' },
    ]

    const decipherHeaders = [
      { text: 'Title', value: 'title' },
      { text: 'Path', value: 'path' }
    ]

    const reset = () => {
      lighthouseProject.value = null
      decipherProject.value = {}
      lighthouseProjectsData.value = []
      decipherProjectsData.value = []
      store.commit('comp-alert/SET_MESSAGE', {})
    }
    
    const closeModal = () => {
      showCreateModal.value = false
      reset()
    }

    const createProject = async () => {
      startLoadingAnimation()
      const payload = JSON.parse(JSON.stringify(lighthouseProject.value))
      payload['decipher_path'] = decipherProject.value['path']
      try {
        const resp = await addProject(payload)
        if (resp.status === 201){
            store.commit('comp-alert/SET_MESSAGE', {})
              showCreateModal.value = false
            router.push({name:'oculis-id', params:{id:resp.data.id}})
            reset()
        } else {
          
              store.commit('comp-alert/SET_MESSAGE', resp.response.data)
              showCreateModal.value = false // Close modal on error to show the alert
        }
      } finally {
        stopLoadingAnimation()
      }
    }


    const lighthouseProjects = computed(() => lighthouseProjectsData.value.map(project => {
        const countries = project.countries
        return countries.map(country => {
            return {
                id:country.id,
                text: `${project.job_number} ${project.job_name} - ${country.country_detail.code}`,
                job_number: project.job_number,
                job_name: project.job_name,
                category: project.category.name,
                country: country.country_detail.name,
                brand: project.brand,
                client: project.client.name,
                office: project.office.name,
                project_type: project.project_type.name,
                service_type: project.service_type.name,
                business_initiative: project.business_initiative.name
            }
        })}).flat()
    )

    const decipherProjects = computed(() => decipherProjectsData.value.map(project => {
            return {
                ...project
            }
        }).flat()
    )

    const createDisabled = computed(() => {
      
      return JSON.stringify(decipherProject.value) == "{}" || lighthouseProject.value == null
    })

    watch(projectSearchQuery,
      async (val, oldVal) => {
          if (val != null && val.length > 2 && lighthouseProject.value == null) {

              lighthouseProjectLoading.value = true
              await fetchProjects(val)

              lighthouseProjectLoading.value = false
          }
        }
    )

    watch(projectDecipherSearch,
      async (val, oldVal) => {
          if (val != null && val.length > 2 && JSON.stringify(decipherProject.value) =="{}") {

              await fetchDecipherProjects({ q: val })

          }
        }
    )


    return {
      showCreateModal, closeModal, currentLoadingText,
      decipherProject, lighthouseProject, projectCreationLoading,
      projectDecipherSearch, headers, projectsData, projectLoading,
      decipherHeaders, decipherProjectLoading, lighthouseProjectLoading,
      projectSearchQuery, lighthouseProjects, decipherProjects, createDisabled,
      oculisProjectSearch, options, totalProjects,
      createProject,
      icons: { mdiMagnify, mdiPlus }
    }
  }
}
</script>

<style scoped>
.illustration-right { position: absolute; bottom: 0; right: 0; opacity: 0.8; }
.illustration-left { position: absolute; top: 2rem; left: 2.5rem; opacity: 0.8; }
.search-field >>> .v-input__append-outer {
  margin-top: 0px !important;
}
.v-data-table__wrapper tbody tr {
    cursor: pointer !important;
}

/* Smooth fade transition for rotating text */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s ease;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>